// components/MotionText.tsx

"use client"; // This makes it a client component

import { motion } from "framer-motion";

interface MotionTextProps {
	title: string;
	description: string;
}

const MotionText: React.FC<MotionTextProps> = ({ title, description }) => {
	return (
		<>
			<motion.h1
				className="font-amarante text-5xl md:text-7xl mb-6 text-center text-white"
				initial={{ opacity: 0, y: -20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8 }}
			>
				<span
					className="headerFont inline-block pb-2 border-b-2 border-red-700"
					dangerouslySetInnerHTML={{ __html: title }} // Render HTML content
				></span>
			</motion.h1>

			<motion.p
				className="text-xl text-gray-300 max-w-3xl mx-auto text-center mb-12"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ delay: 0.3, duration: 0.6 }}
				dangerouslySetInnerHTML={{ __html: description }} // Render HTML content
			></motion.p>
		</>
	);
};

export default MotionText;
